// option-dialog.component.ts
import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { Confirmation } from '../../models/confirmation';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.css',
  imports: [
    MatDialogModule,
    MatCheckboxModule,
    FormsModule,
    MatListModule,
    CommonModule,
    MatTabsModule
  ]
})
export class ConfirmationDialogComponent {

  confirmation: Confirmation;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { confirmation: Confirmation }
  ) {

    this.confirmation = data.confirmation;
    this.confirmation.isOkay = false;

  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    this.confirmation.isOkay = true;
    this.dialogRef.close(this.confirmation);
  }

  isFormValid(): boolean {

    let result = true;
    return result;

  }

}
